var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-dialog-scrollable modal-xs",
        attrs: { role: "document" }
      },
      [
        _vm.board
          ? _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.board.name + " - " + _vm.$t("kanbanLockdownDelay")
                    ) +
                    "\n                "
                ),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.dismiss.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("kanbanLockdownDelayDescription")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("kanbanLockdownDelayDays") + ":") +
                      "\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.lockdownDelayDays,
                        expression: "lockdownDelayDays",
                        modifiers: { number: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.lockdownDelayDays },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.lockdownDelayDays = _vm._n($event.target.value)
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v(_vm._s(_vm.$t("btnCancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "btn btn-primary", on: { click: _vm.save } },
                  [_vm._v(_vm._s(_vm.$t("btnSave")))]
                )
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }